import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { ElLoading } from 'element-plus';
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, formateDate, getImg } from "@/utils/utils";
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import LayerImage from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import DragPan from 'ol/interaction/DragPan';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import PinchRotate from 'ol/interaction/PinchRotate';
import Overlay from 'ol/Overlay';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import { BMapLoader } from '@/utils/bdMap.js';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'
import maptype from '@/view/map/hdmconfig/type';
import maplist from '@/view/map/hdmconfig/list';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
import mappopup from '@/components/map/popup/index';
export default {
  name: 'superMap',
  meta: {
    title: '地图'
  },
  components: {
    VueAudio,
    maptype,
    maplist,
    mappopup
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      // this.$route.query.cfId
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      // this.$route.query.cdId
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      mapconfigData: {
        mapbg: '',
        logo: '',
        type: '',
        staticImg: ''
      },
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapcontainer: '',
      iconLayer: '',
      iconSource: '',
      imageLayer: '',
      wmsLayer: '',
      detail: '',
      // 定点详情对象
      swiperEl: '',
      // 弹窗轮播图ref
      typeList: [],
      // 分类列表
      currentType: 0,
      // 分类默认当前索引
      modeltype: 1,
      // 弹窗默认模板样式
      typemodel: 1,
      // 弹窗默认模板样式
      dotimgW: 100,
      // 定点图片默认宽度
      popshowflag: false,
      // 控制弹窗显隐
      mapconfigdatas: {},
      // 地图管理配置对象
      listyleobj: {},
      // 分类默认样式对象
      listobjon: {},
      // 分类选中样式对象
      // 分类搜索字段
      typesearchStr: {
        'model': 0,
        'filters': [[{
          'id': 1,
          'alias': '3',
          'compt': 'editinput',
          'express': '===',
          'val': '',
          'range': null
        }]]
      },
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      zoom: 0,
      jsonOption: {},
      mtObj: {
        title_font: 'bold 14px 微软雅黑',
        title_color: 'rgba(255,255,255,1)',
        title_bgcolor: 'rgba(0, 0, 255, 0.7)',
        title_bocolor: '',
        offsetX: 0,
        offsetY: 32,
        padding: [2, 10, 1, 10]
      },
      bdDialog: false,
      BDmap: null,
      bdmap: {},
      isApp: false,
      drawsource: '',
      drawLayer: '',
      typeshow: true,
      dataList: '',
      viewCount: 0,
      currentformuser: {},
      xaAreaList: [{
        id: 1,
        name: '莲湖区',
        formUserId: 632216517
      }, {
        id: 2,
        name: '长安区',
        formUserId: 632219591
      }, {
        id: 3,
        name: '周至县',
        formUserId: 632225332
      }, {
        id: 4,
        name: '雁塔区',
        formUserId: 632226201
      }, {
        id: 5,
        name: '碑林区',
        formUserId: 632226575
      }
      // { id: 6, name: '新城区', href: '' },
      // { id: 7, name: '未央区', href: '' },
      // { id: 8, name: '灞桥区', href: '' }
      ],
      xatoIndex: '',
      zhType: {
        level: [{
          label: '国家级',
          value: 2
        }, {
          label: '省级',
          value: 1
        }, {
          label: '市级',
          value: 3
        }],
        area: []
      },
      zhtypeform: {
        level: '',
        mapType: '',
        area: '',
        placeName: ''
      },
      zhListdata: [],
      zhListdataFlag: false,
      searchFlag: false,
      bodywidth: 0,
      overlay: 'undefined',
      // 触摸或点击 不可同时
      isTouch: false,
      noTouch: false,
      defaultIcon: require('../../assets/map/icon_address_red.png'),
      isIpad: false,
      loading: '',
      pointStruct: [],
      pauseTime: 5,
      countDown: null,
      tjthimg: false,
      visitform: {
        formId: 'map_visits',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '146f7409beffcce7387a55a86b9f3908f7823c3fe5626184c9149f3cb3a5eefe'
      } // 浏览量查询字段
    };
  },
  mounted() {
    let userAgent = navigator.userAgent;
    this.isIpad = /macintosh|mac os x/i.test(userAgent) && !userAgent.match(/(iPhone\sOS)\s([\d_]+)/) || userAgent.match(/(iPad).*OS\s([\d_]+)/);
    this.bodywidth = document.body.clientWidth <= 4000 && document.body.clientWidth > 3700 ? 3840 : document.body.clientWidth;
    this.getmapconfigform();
    // 盐池添加云朵动效
    if (this.$route.query.fid === '195382') document.querySelector('.yunbox').style.display = 'block';
    this.$nextTick(() => {
      this.yunAnimate();
    });
    if (document.body.clientWidth < 926) this.isApp = true;
    // 鹤山返回首页按钮事件
    if (this.$route.query.fid === '63095') document.querySelector('.gobackright').style.display = 'block';
    // 西安地图处理
    if (this.$route.query.fid === '5569') this.getMapList();
    this.getpointStruct();
    // 取消默认的上下文菜单显示行为
    document.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });
    // 无操作自动复位
    window.addEventListener('click', this.wHandle.bind(this), false);

    // 鲤城区地图
    if (this.$route.query.fid === '7877') this.currentType = 1;
    this.$nextTick(() => {
      this.loadBmap();
    });
  },
  watch: {},
  methods: {
    // 获取地图管理配置所有数据
    getMapList() {
      let params = {
        deptId: this.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: '',
        orderType: 'asc'
      };
      this.xaAreaList = [];
      this.$api.singleadvanceSearch(params).then(res => {
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
          this.xaAreaList.push({
            id: index,
            formUserId: item.id,
            name: itemformat.title
          });
        });
        this.xaAreaList.shift();
        this.xaAreaList.forEach((elem, index) => {
          if (elem.formUserId === Number(this.$route.query.formUserId)) this.xatoIndex = index;
        });
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: this.xatoIndex,
          slidesPerView: 13,
          speed: 500,
          observeSlideChildren: true,
          observeParents: true,
          observer: true
        });
      });
    },
    // 点位数据 结构表单 解决外链按钮 字段名称自定义
    getpointStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.pointStruct = JSON.parse(JSON.stringify(res));
      });
    },
    onBeforePlay() {},
    // 获取表单字段结构 属性 分类数据
    getformstruct(val) {
      let params = {
        formId: '260297',
        pageSize: 1,
        deptId: this.fid,
        orderBy: val !== '' && val.orderBy !== '' ? val.orderBy : 'manualOrderTop,manualOrder',
        orderType: val !== '' && val.orderType !== '' ? val.orderType : ''
      };
      // 西安 多个地图 分类先去掉筛选
      if (this.fid !== '5569') {
        this.typesearchStr.filters.forEach(item => {
          if (item[0].alias === '3') item[0].val = this.mapconfigdatas['46'] || this.mapconfigdatas['title'];
        });
        params.searchStr = encodeURI(JSON.stringify(this.typesearchStr));
      }
      this.$api.singleadvanceSearch(params).then(res => {
        if (res.dataList.length > 0) {
          this.typeList = [];
          res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            this.typeList.push({
              title: item.itemformdata.title || item.itemformdata[1],
              value: item.itemformdata.title || item.itemformdata[1],
              formUserId: item.id,
              formId: item.formId,
              disabled: true,
              icon: itemformat.icon && itemformat.icon.length > 0 ? itemformat.icon[0].fileUrl : '',
              id: item.itemformdata[2]
            });
            return item;
          });
          // console.log(this.typeList)
        }

        // 鲤城区 地图 默认显示第一个分类数据
        if (this.$route.query.fid == '7877') {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type',
              'compt': 'editinput',
              'express': '===',
              'val': this.typeList[0].title
            }]
          });
        }
        this.initMap(this.mapconfigdatas);
      });
    },
    // 表单无数据返回空
    getformdata(data) {
      let typekey = 'val';
      if (!data.groupValues) return '';
      if (!data.groupValues[0]) return '';
      let groupvalue = data.groupValues[0];
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return groupvalue.values.length && groupvalue.values[0] ? groupvalue.values[0][0] ? groupvalue.values[0][0][typekey] : '' : '';
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 获取地图配置数据 方便多个地图配置
    getmapconfigform() {
      let _this = this;
      this.mapconfigform.deptId = this.fid;
      this.$api.singleformUserId(this.fid, this.mapconfigform.formId, this.formUserId).then(res => {
        // console.log(res)
        _this.currentformuser = res.formUserList[0];
        _this.mapcfData = res.formUserList[0].formData;
        if (res.formUserList.length > 0) {
          _this.mapcfData.forEach(item => {
            _this.mapconfigdatas[transformStr3(item.alias)] = _this.getformitemsdata(item);
          });
          console.log(_this.mapconfigdatas);
          document.title = _this.mapconfigdatas.toptitle = '' ? '地图' : _this.mapconfigdatas.toptitle;
          _this.mapconfig.extent = _this.mapconfigdatas.transformExtent.split(',');
          _this.mapconfig.extent.forEach((item, index) => {
            _this.mapconfig.extent[index] = Number(_this.mapconfig.extent[index]);
          });
          let modeltypeval = _this.mapconfigdatas.modeltype;
          // console.log(modeltypeval)
          _this.modeltype = parseInt(modeltypeval.charAt(modeltypeval.length - 1));
          if (this.fid === '216022') {
            _this.modeltype = 4;
          }
          if (_this.mapconfigdatas.textbg) _this.colorConfig(_this.mapconfigdatas.textbg, '--hand-drawn-pop-textbg');
          if (_this.mapconfigdatas.colorTheme1) _this.colorConfig(_this.mapconfigdatas.colorTheme1, '--hand-drawn-pop-colortheme1');
          if (_this.mapconfigdatas.colorTheme2) _this.colorConfig(_this.mapconfigdatas.colorTheme2, '--hand-drawn-pop-colortheme2');
          if (_this.modeltype === 3) {
            if (_this.mapconfigdatas.colorTheme1) {
              _this.colorConfig(_this.mapconfigdatas.colorTheme1, '--hand-drawn-pop-colortheme07', 0.7);
              _this.colorConfig(_this.mapconfigdatas.colorTheme1, '--hand-drawn-pop-colortheme01', 0.1);
            }
          }
          if (_this.mapconfigdatas.mapmodetype === '切片地图') {
            _this.mapconfig.mapMinZoom = Number(_this.mapconfigdatas.mapMinLevel);
            _this.mapconfig.mapMaxZoom = Number(_this.mapconfigdatas.mapMaxLevel);
          }
          if (_this.mapconfigdatas.mapmodetype === '静态地图') {
            _this.mapconfig.mapMinZoom = Number(_this.mapconfigdatas.staticMapMinLevel);
            _this.mapconfig.mapMaxZoom = Number(_this.mapconfigdatas.staticMapMaxLevel);
            _this.mapconfigData.staticImg = _this.mapconfigdatas.staticImg;
          }
          if (document.body.clientWidth < 768) {
            _this.mapconfigData.mapbg = _this.mapconfigdatas.appBgImg;
            _this.dotimgW = _this.mapconfigdatas.appimgW;
            _this.mapconfig.currentZoom = Number(_this.mapconfigdatas.appCurrentLevel);
            _this.mapconfig.center = _this.mapconfigdatas.appMapCenter.split(',');
            _this.mapconfig.center.forEach((item, index) => {
              _this.mapconfig.center[index] = Number(_this.mapconfig.center[index]);
            });
            if (_this.fid === '209984') _this.mapconfigdatas.logo = require('../../assets/map/209984/logo.png');
            if (_this.$route.query.formUserId === '680472626') _this.mapconfigdatas.logo = require('../../assets/map/219539/logo.png');
          } else {
            _this.mapconfigData.mapbg = _this.mapconfigdatas.backgroundImg;
            _this.dotimgW = _this.mapconfigdatas.dotimgW;
            _this.mapconfig.currentZoom = Number(_this.mapconfigdatas.currentLevel);
            _this.mapconfig.center = _this.mapconfigdatas.mapCenter.split(',');
            _this.mapconfig.center.forEach((item, index) => {
              _this.mapconfig.center[index] = Number(_this.mapconfig.center[index]);
            });
          }
          _this.listyleobj.width = _this.mapconfigdatas.typewidth + 'px';
          _this.listyleobj.height = _this.mapconfigdatas.typeheight + 'px';
          _this.listyleobj.lineHeight = _this.mapconfigdatas.typeheight + 'px';
          _this.listyleobj.color = _this.mapconfigdatas.typecolor;
          if (_this.mapconfigdatas.typebg !== '') _this.listyleobj.background = 'url(' + _this.mapconfigdatas.typebg + ') center center 100% no-repeat';
          _this.listobjon.width = _this.mapconfigdatas.typewidth + 'px';
          _this.listobjon.height = _this.mapconfigdatas.typeheight + 'px';
          _this.listobjon.lineHeight = _this.mapconfigdatas.typeheight + 'px';
          _this.listobjon.color = _this.mapconfigdatas.typefocuscolor + '!important';
          if (_this.mapconfigdatas.typefocusbg !== '') {
            _this.listobjon.background = 'url(' + _this.mapconfigdatas.typefocusbg + ') no-repeat!important';
            _this.listobjon.backgroundSize = '100% 100%!important';
            _this.listobjon.backgroundPosition = 'center!important';
          }
          let typeform = '';
          if (_this.mapconfigdatas.jsontxt && _this.mapconfigdatas.jsontxt !== '') {
            _this.jsonOption = JSON.parse(_this.getStr(_this.mapconfigdatas.jsontxt));
            // console.log(_this.jsonOption)
            if (_this.jsonOption.point) {
              Object.keys(_this.jsonOption.point).forEach(item => {
                _this.mtObj[item] = _this.jsonOption.point[item];
              });
            }
            if (_this.jsonOption.type) {
              typeform = _this.jsonOption.type;
              _this.typemodel = _this.jsonOption.type.model.replace('模板', '');
              if (_this.jsonOption.type.typeflag === '否') this.typeshow = false;
            }
            if (_this.jsonOption.footerinfo) {
              _this.mapconfigdatas.footerinfo = _this.jsonOption.footerinfo;
              _this.viewCount = parseInt(_this.jsonOption.footerinfo.viewCount) + parseInt(_this.jsonOption.footerinfo.viewplus);
              // 记录浏览量
              if (_this.mapconfigdatas.visits === undefined) _this.setViewCount(_this.viewCount);
            }
          }
          if (_this.mapconfigdatas.visits !== undefined) _this.setNewViewCount();
          // 
          // if (this.bodywidth === 3840) _this.mapconfig.currentZoom = Number(_this.mapconfig.currentZoom) * 1.001
          // console.log(`_this.mapconfig.currentZoom:"${_this.mapconfig.currentZoom}`)
          // 初始化地图及层级
          // console.log(_this.mapconfigdatas)
          // 获取分类数据
          _this.getformstruct(typeform);
          // console.log(_this.listobjon)
          // 焦作增加访问量
          if (this.fid == 220706 && this.mapconfigdatas.fwl) {
            this.changeView();
          }
        }
      });
    },
    initMap(data) {
      // console.log(data)
      // 清空mapcontent内的元素
      let mapcontent = document.querySelector('#map');
      if (mapcontent.childNodes.length > 0) {
        mapcontent.removeChild(mapcontent.childNodes[0]);
      }
      this.map = null;
      if (data.mapmodetype === '切片地图') this.Tilemap();
      if (data.mapmodetype === '静态地图') this.staticmap();
      // 获取地图配置项后 取当前层级渲染
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0) {
          item.filters.forEach(child => {
            if (child.alias === '40') child.val = data['46'] || data['title'];
          });
        }
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
    },
    /**
     * 设置访问量
     */
    setViewCount(val) {
      let num = val + 1;
      let formData = {
        deptId: this.$route.query.fid,
        formId: this.currentformuser.formId,
        formUserId: this.formUserId || this.$route.query.formUserId
      };
      // console.log(this.jsonOption)
      this.jsonOption.footerinfo.viewCount = num;
      let dataList = [{
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': this.mapconfigdatas.onlyid
        }]
      }, {
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.mapconfigdatas.title
        }]
      }, {
        'alias': 'jsontxt',
        'compt': 'richtext',
        'values': [{
          'val': '<p element-id=\"init\" style="display: none;">' + JSON.stringify(this.jsonOption) + '</p>'
        }]
      }];
      this.$api.editForm(formData.deptId, formData.formUserId, encodeURI(JSON.stringify(dataList)), formData.formId).then(res => {});
    },
    /**
     * 设置访问量【存储浏览量表单】
     * @date 2025-04-18
     */
    setNewViewCount() {
      let that = this;
      let nowTime = new Date();
      let date = formateDate(nowTime, 'yyyy-MM-dd');
      const searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'id',
            'compt': 'editinput',
            'express': '===',
            'val': this.mapconfigdatas.onlyid
          }, {
            'alias': 'date',
            'compt': 'editinput',
            'express': '===',
            'val': date
          }]
        }]
      };
      this.visitform.deptId = this.$route.query.fid;
      this.visitform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.visitform).then(res => {
        res.totalRow > 0 ? that.editVisit(res, nowTime) : that.addVisit(nowTime, date);
      });
    },
    addVisit(nowTime, date) {
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': ''
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.mapconfigdatas.title
        }]
      });
      dataList.push({
        'alias': 'id',
        'compt': 'editinput',
        'values': [{
          'val': this.mapconfigdatas.onlyid
        }]
      });
      dataList.push({
        'alias': 'date',
        'compt': 'editinput',
        'values': [{
          'val': date
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': 1
        }]
      });
      console.log(`dataList`, dataList);
      let formData = {
        deptId: this.$route.query.fid,
        formId: this.visitform.formId,
        uid: this.$route.query.uid
      };
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {});
    },
    editVisit(res, nowTime) {
      let resList = this.formdataformat(res);
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': resList[0].itemformdata.onlyid
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.mapconfigdatas.title
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': Number(resList[0].itemformdata.visits) + 1
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      this.$api.editForm(this.$route.query.fid, resList[0].id, encodeURI(JSON.stringify(dataList)), resList[0].formId).then(res => {});
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    // 处理颜色
    colorConfig(data, name, alpha) {
      // console.log(name)
      if (alpha !== undefined) {
        document.documentElement.style.setProperty(name, `rgba(${this.set16ToRgb(data)}, ${alpha})`);
      } else {
        let themecolor = '';
        if (data.includes('#')) themecolor = data;
        document.documentElement.style.setProperty(name, themecolor);
      }
    },
    getStr(str) {
      return str.replace(/(<\/?p.*?>)/gi, '');
    },
    // 获取地图点数据
    getmapdataform() {
      let that = this;
      this.mapdataform.deptId = this.fid;
      this.loading = ElLoading.service({
        lock: true,
        text: '数据加载中',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        console.log(res);
        if (res.dataList.length > 0) {
          if (res.totalPage === 1) {
            that.iconSource.clear();
            that.dataformat(res);
            that.loading.close();
          } else {
            if (that.mapdataform.page === 1) {
              that.iconSource.clear();
              that.dataformat(res);
            } else {
              that.dataformat(res);
            }
            that.mapdataform.page++;
            if (res.totalPage >= that.mapdataform.page) that.getmapdataform();
            if (res.totalPage === that.mapdataform.page) that.loading.close();
          }
        } else {
          that.loading.close();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        if (itemformat.pca !== undefined && itemformat.pca.toString() !== '') {
          let areaArr = itemformat.pca.split('|')[1];
          item.itemformdata.area = areaArr.split(',')[2];
        }
        this.createPoint(itemformat, item);
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        });
      } else {
        this.dataList.concat(res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        }));
      }
    },
    createPoint(itemformat, item) {
      // console.log(this.jsonOption)
      // console.log(itemformat)
      let _this = this;
      let zoom = Math.round(this.map.getView().getZoom());
      let zoomdifference = Number(zoom) - Number(this.mapconfig.currentZoom);
      // console.log(itemformat)
      if (itemformat['34'] === '隐藏') return false;
      if (!itemformat.mapCoordinates) return;
      let c = itemformat['mapCoordinates'].split(',');
      let cX = Number(c[0]);
      let cY = Number(c[1]);
      let imgtextFeature = new Feature({
        geometry: new Point(fromLonLat([cX, cY])),
        id: item.id,
        name: itemformat['placeName'],
        xy: [cX, cY]
      });
      // 处理点位文字
      let textstyle = '';
      if (this.mapconfigdatas['locationTitle'] === '显示' || itemformat.showplaceName === '是') {
        let setOffset = [0, 32];
        if (itemformat['titleoffset'] && itemformat['titleoffset'].toString() !== '' && !itemformat.titleoffset.includes('NaN')) {
          setOffset = itemformat['titleoffset'].replace(/，/, ',').split(',');
        }
        let stroke = this.mtObj.title_bocolor;
        let placename = itemformat['placeName'];
        if (placename.length > 10) {
          placename = insertStr(placename, 10, ',');
        }
        textstyle = new StyleText({
          text: placename.includes(',') ? placename.split(',').join('\n') : placename,
          font: this.mtObj.title_font,
          fill: new StyleFill({
            color: this.mtObj.title_color
          }),
          offsetX: setOffset[0],
          offsetY: itemformat.show4 === '否' ? 0 : zoomdifference > 1 ? zoomdifference * 5 + Number(setOffset[1]) : Number(setOffset[1]),
          backgroundFill: new StyleFill({
            color: this.mtObj.title_bgcolor
          }),
          stroke: stroke !== '' ? new StyleStroke({
            color: stroke,
            width: 2
          }) : '',
          padding: [2, 10, 0, 10]
        });
      }
      // console.log(this.jsonOption.point)
      if (this.jsonOption.point && this.jsonOption.point.location_title && this.jsonOption.point.location_title !== '显示') textstyle = '';
      // 处理点位图片
      let ispointImg = this.jsonOption.point && this.jsonOption.point.pointImg && this.jsonOption.point.pointImg !== '是';
      let imageicon = itemformat[4].length === 0 ? '' : ispointImg ? '' : new StyleIcon({
        radius: 4,
        src: getImg(itemformat[4][0]),
        offset: [0, 0],
        width: 100
      });
      imgtextFeature.setStyle(new Style({
        image: itemformat.show4 === '否' ? '' : imageicon,
        text: itemformat.showplaceName === '否' ? '' : textstyle
      }));
      let iconstyle = imgtextFeature.getStyle();
      if (iconstyle.getText()) {
        let textscale = zoomdifference > 1 ? zoomdifference * 0.1 + 1 : 1;
        iconstyle.getText().setScale(textscale);
      }
      // 处理点位图片宽度自适应地图
      if (itemformat.show4 !== '否' && imageicon !== '') {
        let img = new Image();
        img.src = iconstyle.image_.iconImage_.src_;
        img.onload = function () {
          let width = img.width;
          // 以宽度为100为例
          let imgmultiple = (itemformat.picwidth !== undefined && itemformat.picwidth.length !== 0 ? parseInt(itemformat.picwidth) : _this.dotimgW) / width;
          let scale = zoomdifference > 1 ? imgmultiple * (zoomdifference - 0.5) : imgmultiple;
          iconstyle.getImage().setScale(imgmultiple);
          imgtextFeature.setStyle(iconstyle);
          _this.iconSource.addFeature(imgtextFeature);
        };
      } else {
        imgtextFeature.setStyle(iconstyle);
        this.iconSource.addFeature(imgtextFeature);
      }
      // 处理点位图标
      if (this.jsonOption.point && this.jsonOption.point.pointIcon && this.jsonOption.point.pointIcon === '是') {
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat([cX, cY])),
          id: `${item.id}`,
          name: itemformat.placeName,
          xy: [cX, cY],
          image: itemformat[4].length === 0 ? '' : handleHttp(itemformat[4][0].fileUrl),
          picwidth: itemformat.picwidth
        });
        let icon = itemformat.mapType === '' ? this.defaultIcon : this.getTypeIcon(itemformat['43']);
        if (icon !== '') {
          iconFeature.setStyle(new Style({
            image: new StyleIcon({
              radius: 4,
              src: icon,
              offset: [0, 0],
              width: 28
            })
          }));
          this.iconSource.addFeature(iconFeature);
        }
      }
    },
    getTypeIcon(id) {
      let icon = this.defaultIcon;
      this.typeList.forEach(elem => {
        if (Number(elem.id) === Number(id)) {
          if (elem.icon && elem.icon !== '') icon = elem.icon;
        }
      });
      return icon;
    },
    // 获取切片地图
    Tilemap() {
      // console.log(this.mapconfig)
      this.mapcontainer = this.$refs.maps;
      const mapExtent = transformExtent(this.mapconfig.extent, 'EPSG:4326', 'EPSG:3857');
      this.drawsource = new VectorSource();
      this.drawLayer = new VectorLayer({
        source: this.drawsource,
        style: this.styleFunction
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.wmsLayer = new TileLayer({
        extent: mapExtent,
        source: new XYZ({
          attributions: [new Attribution({
            html: '1; Rendered with <a href="https://www.maptiler.com/">MapTiler Desktop</a>'
          })],
          url: 'tiles/' + this.formUserId + '/{z}/{x}/{y}.png',
          tilePixelRatio: 1.000000,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        target: this.mapcontainer,
        layers: [this.wmsLayer, this.iconLayer, this.drawLayer],
        logo: false,
        view: new View({
          center: fromLonLat(this.mapconfig.center),
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.mapLoadEnd(this.mapconfigdatas);
    },
    // 静态地图
    staticmap() {
      this.mapcontainer = this.$refs.maps;
      let extent = this.mapconfig.extent;
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      this.imageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: this.handleHttp(this.mapconfigData.staticImg),
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.drawsource = new VectorSource();
      this.drawLayer = new VectorLayer({
        source: this.drawsource,
        style: this.styleFunction
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [this.imageLayer, this.iconLayer, this.drawLayer],
        target: this.mapcontainer,
        view: new View({
          projection: projection,
          center: this.mapconfig.center,
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.mapLoadEnd(this.mapconfigdatas);
    },
    mapLoadEnd(data) {
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
      // console.log(this.jsonOption)
      if (this.fid === '216022' && !this.isApp) getdragPan(this.map);
      if (data.jsontxt && data.jsontxt !== '') {
        if (this.jsonOption.map) {
          if (this.jsonOption.map.dragazoom && this.jsonOption.map.dragazoom === '是') getPan(this.map);
          if (this.jsonOption.map.dragrotate && this.jsonOption.map.dragrotate === '是') getPinchRotate(this.map);
        }
        if (this.jsonOption.draw && !this.isApp) {
          let style = this.jsonOption.drawstyle;
          let drawObj = JSON.parse(this.jsonOption.draw);
          const splitfeature = new GeoJSON().readFeatures(this.jsonOption.draw);
          // console.log(splitfeature)
          splitfeature.forEach((elem, index) => {
            elem.setStyle(new Style({
              stroke: new StyleStroke({
                color: style[index].color,
                width: style[index].size / 2,
                lineDash: style[index].lineDash
              })
            }));
            this.drawsource.addFeature(elem);
          });
        }
      }
      // 地图监听 触摸事件 触摸开始
      let mapDom = document.querySelector('#map');
      let _this = this;
      mapDom.addEventListener('touchstart', e => {
        // _this.noTouch = false
        if (data.jsontxt && data.jsontxt !== '') {
          if (this.jsonOption.map) {
            if (this.jsonOption.map.dragazoom && this.jsonOption.map.dragazoom === '是') getPan(this.map);
            if (this.jsonOption.map.dragrotate && this.jsonOption.map.dragrotate === '是') getPinchRotate(this.map);
          }
        }
        // 
        _this.isTouch = true;
        if (e.targetTouches.length < 3) {
          let zoom = Math.round(this.map.getView().getZoom());
          if (zoom > this.mapconfig.mapMaxZoom) {
            this.map.getView().setZoom(this.mapconfig.mapMaxZoom);
          }
          this.map.on('moveend', function (event) {
            _this.resolutionchange(event);
          });
        } else {
          // _this.noTouch = true
        }
      });
      // 缩放地图 结束后事件
      this.map.on('moveend', function (event) {
        if (!_this.isTouch) {
          _this.resolutionchange(event);
        }
      });
    },
    styleFunction(feature) {
      const styles = [
      // linestring
      new Style({
        stroke: new StyleStroke({
          color: '#877d6a',
          width: 1,
          lineDash: [4, 2]
        })
      })];
      return styles;
    },
    // 获取当前 地图位置
    singleclick(val) {
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6));
    },
    // 处理表单数据
    getformitemdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'videobox' || data.compt === 'fileupload' || data.compt === 'imagebox' || data.compt === 'location' || data.compt === 'selectmultibox') return data.values.length ? data.values : '';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 处理请求协议
    handleHttp(val) {
      let currenthttp = location.protocol;
      if (val !== undefined) {
        if (currenthttp === 'https:') {
          return val.replace('http:', currenthttp);
        } else {
          return val;
        }
      }
    },
    // 鼠标移入显示
    markermove(evt) {
      let allfeatures = this.iconSource.getFeatures();
      allfeatures.forEach(item => {
        if (item.get('hover')) {
          this.iconSource.removeFeature(item);
        }
      });
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureName = feature.get('name');
        let featureCenter = feature.get('xy');
        let featureId = feature.get('id');
        let featureImage = feature.get('image');
        let picwidth = feature.get('picwidth');
        this.hoverId = featureId;
        if (!featureCenter) return;
        if (this.jsonOption.point && this.jsonOption.point.location_title === '2') {
          const yvalue = 0.0006 / (this.zoom * (this.zoom + 1));
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let textFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          let stroke = this.mtObj.title_bocolor;
          textFeature.setStyle(new Style({
            text: new StyleText({
              text: featureName,
              font: this.mtObj.title_font,
              fill: new StyleFill({
                // 可以在此处设置字体样式，与css同
                color: this.mtObj.title_color
              }),
              offsetX: this.mtObj.offsetX,
              offsetY: 0,
              backgroundFill: new StyleFill({
                color: this.mtObj.title_bgcolor
              }),
              stroke: stroke !== '' ? new StyleStroke({
                color: stroke,
                width: 2
              }) : '',
              padding: this.mtObj.padding
            })
          }));
          this.iconSource.addFeature(textFeature);
        }
        if (this.jsonOption.point && this.jsonOption.point.pointImg === '2') {
          if (!featureImage) return;
          const yvalue = 0.0015 / (this.zoom * 2);
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let imgFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          imgFeature.setStyle(new Style({
            image: new StyleIcon({
              src: featureImage
            })
          }));
          // this.iconSource.addFeature(imgFeature)
          let that = this;
          let imgstyle = imgFeature.getStyle();
          let img = new Image();
          img.src = imgstyle.image_.iconImage_.src_;
          img.onload = function () {
            let width = img.width;
            // 以宽度为100为例
            let imgmultiple = that.isApp ? that.mapconfigdatas.appimgW / width : (picwidth !== undefined && picwidth.length !== 0 ? parseInt(picwidth) : that.mapconfigdatas.dotimgW) / width;
            imgstyle.getImage().setScale(1);
            imgFeature.setStyle(imgstyle);
            // console.log(that)
            that.iconSource.addFeature(imgFeature);
          };
        }
      }
    },
    // 点击当前 定位点 详情
    markerclick(evt, type) {
      let feature = '';
      if (evt.id) {
        feature = evt;
      } else {
        feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature;
        });
      }
      this.overlay = undefined;
      this.popshowflag = false;
      if (feature) {
        let featureId = feature.id ? feature.id : feature.get('id');
        // console.log(featureId)
        let _this = this;
        this.$api.singleformUserId(this.fid, this.mapdataform.formId, featureId).then(res => {
          let detaildata = res.formUserList[0].formData;
          let deatilObj = {
            currentShowtype: 'banner'
          };
          detaildata.forEach(item => {
            deatilObj[transformStr3(item.alias)] = _this.getformitemdata(item);
          });
          // console.log(deatilObj)
          deatilObj.audio = deatilObj.audio !== '' ? deatilObj.audio.map(item => {
            item.title = item.name.replace(`.${item.suffix}`, '');
            this.$api.getUrlByObjectId(item.objectId).then(res => {
              let currenthttp = location.protocol;
              item.url = res.http;
            });
            return item;
          }) : '';
          deatilObj.video = deatilObj.video !== '' ? deatilObj.video.map(item => {
            item.title = item.name.replace(`.${item.suffix}`, '');
            this.$api.getUrlByObjectId(item.objectId).then(res => {
              let currenthttp = location.protocol;
              item.url = res.http;
            });
            return item;
          }) : '';

          // if (deatilObj.video.length > 0) {
          //   let videoTimer = setTimeout(() => {
          //     if (deatilObj.video[0].url !== undefined) {
          //       clearTimeout(videoTimer)
          //       deatilObj.cVideourl = deatilObj.video[0].url
          //       deatilObj.cVideotitle = deatilObj.video[0].title
          //     }
          //   }, 500)
          // }
          this.detail = deatilObj;
          console.log(`this.detail`, this.detail);

          // 外链是否打开新窗口字段判断
          if (deatilObj['44'] !== '') {
            if (this.detail.linkTarget !== undefined && this.detail.linkTarget === '是') {
              window.open(deatilObj['44']);
              return;
            }
            location.href = deatilObj['44'];
          } else {
            if (deatilObj['42'] === '') return;
            if (deatilObj['42'] === '链接' && deatilObj['44'] === '') return;
            if (deatilObj['42'] === '仅展示') return;
            // 珠海点击弹窗 使用overlay方式 可跟随点
            this.popshowflag = true;
            if (this.fid === '216022') {
              const container = document.querySelector('.popcontainer-style4');
              this.overlay = new Overlay({
                element: container
              });
              let mapcoordinate = evt.id ? fromLonLat(feature.itemformdata.mapCoordinates.split(',')) : evt.coordinate;
              // console.log(mapcoordinate)
              let coordinate = mapcoordinate.map((item, index) => {
                if (index === 1) item = item + 58;
                return item;
              });
              this.overlay.setPosition(coordinate);
              this.map.addOverlay(this.overlay);
            }
          }
          // console.log(this.detail)
        });
      }
    },
    // 地图实时放大缩小事件
    resolutionchange(event) {
      if (this.bodywidth === 3840) document.querySelector('.ol-layer').style.transform = 'scale(2.5)';
      let zoom = Math.round(event.map.getView().getZoom());
      if (this.zoom === zoom) return;
      this.zoom = zoom;
      let minZoom = this.mapconfig.mapMinZoom;
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '===',
          'val': i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.model === 1) item.filters = orData;
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    isInteger(obj) {
      return typeof obj === 'number' && obj % 1 === 0;
    },
    // 筛选类型
    typeselect(data) {
      console.log(data);
      // 天津红桥桃花阅读地图图片 定制
      this.tjthimg = this.fid === '254006' && data.item.id === '00004' ? true : false;
      let val = data.item;
      let index = data.index;
      this.detail = '';
      let typesearchflag = false;
      if (val.value === '全部') {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters[0].alias === 'map_type') this.searchStr.filters.splice(index, 1);
        });
        this.currentType = 0;
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters[0].alias === 'map_type') {
            item.filters[0].val = val.value;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type',
              'compt': 'editinput',
              'express': '===',
              'val': val.title
            }]
          });
        }
        this.currentType = index + 1;
      }
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    // 弹窗关闭事件
    closeHandle() {
      this.detail = '';
      this.popshowflag = false;
    },
    yunAnimate() {
      if (this.$route.query.fid === '195382') {
        setTimeout(() => {
          document.querySelector('.yunbox').remove();
        }, 2800);
      }
    },
    set16ToRgb(str) {
      var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
      if (!reg.test(str)) {
        return;
      }
      let newStr = str.toLowerCase().replace(/\#/g, '');
      let len = newStr.length;
      if (len == 3) {
        let t = '';
        for (var i = 0; i < len; i++) {
          t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
        }
        newStr = t;
      }
      let arr = []; //将字符串分隔，两个两个的分隔
      for (var i = 0; i < 6; i = i + 2) {
        let s = newStr.slice(i, i + 2);
        arr.push(parseInt("0x" + s));
      }
      return arr.join(",");
    },
    // 返回首页
    gobackright() {
      // console.log(this.mapconfig.center)
      this.popshowflag = false;
      let center = this.mapconfigdatas.mapmodetype === '切片地图' ? fromLonLat(this.mapconfig.center) : this.mapconfig.center;
      this.map.getView().animate({
        zoom: this.mapconfig.currentZoom,
        center: center,
        rotation: 0,
        duration: 1000
      });
      this.iconSource.clear();
      this.mapdataform.page = 1;
      this.getmapdataform();
    },
    listmarkerclick(item) {
      this.markerclick(item, 1);
    },
    // 西安处理导航链接
    xatoLink(val) {
      this.zoom = 0;
      this.formUserId = val;
      let isHasIndex = false;
      this.isTouch = false;
      this.xaAreaList.forEach((elem, index) => {
        if (elem.formUserId === Number(val)) {
          this.typeshow = true;
          this.xatoIndex = index;
          isHasIndex = true;
        }
      });
      if (!isHasIndex) {
        this.xatoIndex = '';
        this.typeshow = false;
      }
      this.getmapconfigform();
    },
    /*
    ** 监听 倒计时 2024/01/22
    */
    wHandle(ev) {
      this.pauseTime = 5 * 60;
      clearInterval(this.countDown);
      this.countDown = setInterval(() => {
        if (this.pauseTime >= 0) {
          --this.pauseTime;
        } else {
          clearInterval(this.countDown);
          this.gobackright();
        }
      }, 1000);
    },
    loadBmap() {
      BMapLoader().then(BMap => {
        this.BDMap = new BMap.Map('bdmap');
        let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(a => {
          console.log(a);
          this.bdmap.address = a.address;
          this.bdmap.lng = a.point.lng;
          this.bdmap.lat = a.point.lat;
          localStorage.setItem('bdlocation', JSON.stringify(this.bdmap));
        });
      });
    },
    // 修改点击量/浏览量
    changeView(type) {
      let dataList = [{
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': this.mapconfigdatas.onlyid
        }]
      }, {
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.mapconfigdatas.title
        }]
      }];
      if (type != 'click') {
        dataList.push({
          'alias': 'fwl',
          'compt': 'numberinput',
          'values': [{
            'val': parseInt(this.mapconfigdatas.fwl) + 1
          }]
        });
      } else {
        dataList.push({
          'alias': 'djl',
          'compt': 'numberinput',
          'values': [{
            'val': parseInt(this.mapconfigdatas.djl)
          }]
        });
      }
      let formData = {
        deptId: this.$route.query.fid,
        formId: this.currentformuser.formId,
        formUserId: this.formUserId || this.$route.query.formUserId
      };
      this.$api.editForm(formData.deptId, formData.formUserId, encodeURI(JSON.stringify(dataList)), formData.formId).then(res => {});
    },
    // 焦作博物馆增加点击量
    addClickNum() {
      if (this.fid == 220706 && this.mapconfigdatas.fwl) {
        this.mapconfigdatas.djl = parseInt(this.mapconfigdatas.djl) + 1;
        this.changeView('click');
      }
    }
  }
};